export enum TypePageErreur {
	SSO = 0,
	ListeSocietes = 1
}



// WEBPACK FOOTER //
// ./src/shared/models/typePageErreur.ts